import React, { useEffect, useState } from "react";
import ReactTable from "react-table";
import * as notify from "../shared/notify";

import ImageGallery from "./components/image-gallery";
import ReactTablePagination from "../components/task-list/components/pagination";
import TaskNav from "../components/task-nav/task-nav";

import { getProductById, updateStatusByIds } from "./lib/stagingData";
import { getComponentTypes, readOnlyValue } from "../components/attributes/lib/attribute-data";
import { useNavigate, useParams } from "react-router-dom";

const COLUMNS = [
    {
        Header: "Attribute",
        accessor: "label",
        width: 300,
    },
    {
        Header: "Value",
        accessor: "value",
    },
    {
        Header: "Type",
        accessor: "componentType",
        width: 120,
    },
];

const emptyProduct = {
    attributes: [],
    images: [],
};

const PreshipmentUpcIndex = () => {
    const params = useParams();
    const navigate = useNavigate();
    const productId = params.id;
    const [product, setProduct] = useState({ ...emptyProduct });

    useEffect(() => {
        async function fetchProduct() {
            const productData = await getProductById(productId);
            const fetchedComponentTypes = await getComponentTypes();

            if (!productData) {
                return;
            }

            const newAttributes = productData.productData.attributes.map((a) => {
                const componentType = fetchedComponentTypes[a.componentType];

                return { ...a, value: readOnlyValue(a.value, componentType, { ...a, additionalInfo: a.additionalInformation }), componentType: componentType };
            });
            setProduct({
                attributes: newAttributes,
                feedId: productData.feedId,
                id: productData.id,
                images: productData.images || [],
            });
        }

        fetchProduct();
    }, []);

    const statusClick = async (statusText) => {
        const note = await notify.prompt(`Are you sure you want this record ${statusText.toLowerCase()}?`);

        if (note === false) {
            return;
        }

        const response = await updateStatusByIds([product], statusText, note);

        if (!response) {
            return;
        }

        notify.success(`Records ${statusText}`);
        navigate(`/preshipment`);
    };

    const getTrProps = (state, rowInfo, column, instance) => {
        const style = {};

        if (rowInfo && !rowInfo.original.value) {
            style.backgroundColor = "rgba(255, 204, 204, 0.5)";
        }

        return {
            style: style,
        };
    };

    return (
        <div>
            <TaskNav>
                <div className="button-group -right">
                    <h1>Preshipment Upc</h1>
                    <button
                        className="button -primary"
                        onClick={() => {
                            statusClick("Completed");
                        }}
                    >
                        Accept
                    </button>
                    <button
                        className="button -warning"
                        onClick={() => {
                            statusClick("OnHold");
                        }}
                    >
                        Hold
                    </button>
                    <button
                        className="button -error"
                        onClick={() => {
                            statusClick("Rejected");
                        }}
                    >
                        Ignore
                    </button>
                </div>
            </TaskNav>
            <h2>Attributes ({product.attributes.length})</h2>
            <ReactTable
                filterable
                defaultFilterMethod={(filter, row) => {
                    if (filter.value && row[filter.id]) {
                        return String(row[filter.id].toString().toLowerCase()).includes(filter.value.toLowerCase());
                    }
                }}
                getTrProps={getTrProps}
                PaginationComponent={ReactTablePagination}
                data={product.attributes}
                columns={COLUMNS}
                minRows="10"
            />
            <br />
            <hr />
            <br />
            <h2>Images ({product.images.length})</h2>
            <ImageGallery images={product.images} productId={productId} />
        </div>
    );
};

export default PreshipmentUpcIndex;
